import React, { FC, useRef } from "react";
import { useDrag } from "react-dnd";
import { Form } from "../../../models/formModel";
import { ItemTypes } from "../../../utils/itemTypes";
import "../prototypeComponent.scss";

export interface FormCardComponentProps {
  form: Form;
}

const FormCardComponent: FC<FormCardComponentProps> = ({ form }) => {
  const ref = useRef<HTMLDivElement>(null);

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.FORM_DRAG,
    item: form,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  drag(ref);

  return (
    <div ref={ref} className="prototype-form-item">
      <span className="items-word-wrap">{form.name}</span>
    </div>
  );
};

export default FormCardComponent;
